module.exports = __webpack_public_path__ + "static/media/Casino1.46aeba02.webp";